import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import * as moment from 'moment';
import { FilterFieldValue } from '../../../covance-filter';
import { AdminActivityReportsFilterResolver } from '../documents/admin-activity-reports-filter-resolver';

@Injectable()
export class SetDefaultAdminEmailNotificationFiltersGuard implements CanActivate {

    constructor(
        private readonly router: Router,
        private readonly filtersResolver: AdminActivityReportsFilterResolver,
    ) { }

    public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const filters = this.filtersResolver.resolveFilters('email-notification');
        if (!this.checkFilterParamsAreSet(filters, route)) {
            this.setDefaultFilter(route, state);
            return false;
        }

        return true;
    }

    private checkFilterParamsAreSet(filters: FilterFieldValue[], route: ActivatedRouteSnapshot) {
        return filters.length === 0 || filters.filter(f => f.def.isServerSideFilter).some(f => route.queryParams[f.def.queryParam]);
    }

    private setDefaultFilter(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const emailNotificationDefaultDateRange = 7;
        const defaultDateFrom = moment().subtract(emailNotificationDefaultDateRange, 'days').format('YYYY-MM-DD');
        const defaultDateTo = moment().format('YYYY-MM-DD');
        this.router.navigate([state.url], {
            queryParams: { sentDate: `${defaultDateFrom}To${defaultDateTo}` }
        });
    }
}